<template>
    <main class="mt-5">
        <span id="add-btn">
            <button :disabled="hasPermission('write_customer') ? false : true" @click="createModal()"class="btn btn-success">پیام جدید</button>
        </span>
        <b-tooltip v-if="!hasPermission('write_customer')" target="add-btn" triggers="hover">
        شما به این بخش دسترسی ندارید
        </b-tooltip>
        <!-- <b-tooltip v-if="!hasPermission('write_customer')" target="add-btn" triggers="hover">
            شما به این بخش دسترسی ندارید
        </b-tooltip> -->
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold">پیام های ارسال شده</h5>
                <div style="flex:1"></div>
            </div>
            <div class="card-body">
                <div>
                    <b-table responsive hover bordered :items="items.data" :fields="fields">
                        <template v-slot:cell(index)="data">
                            {{ data.index + 1}}
                        </template>
                        <template v-slot:cell(read_at)="data">
                            {{ data.item.read_at | persianDate}}
                        </template>
                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate}}
                        </template>
                        <!-- <template v-slot:cell(stores)="data">
                            <button   
                                class="btn btn-sm btn-dark"   
                                type="button"    
                                data-toggle="modal"   
                                :data-target="'#sort-stores-' + data.item.id">  
                                مشاهده  
                            </button>  
                        </template> -->
                        <template v-slot:cell(edit)="data">
                            <span :id="'edit-btn-' + data.item.id">
                                <a :disabled="!hasPermission('read_customer') ? true : false" class="action-btns1  pt-1 px-2"
                                    @click="editModal(data.item)">
                                    <i class="feather feather-edit text-primary"></i>
                                </a>
                            </span>
                            <b-tooltip v-if="!hasPermission('read_customer')" :target="'edit-btn-' + data.item.id" triggers="hover">
                                شما به این بخش دسترسی ندارید
                            </b-tooltip>
                        </template>
                        <template v-slot:cell(delete)="data">
                            <span :id="'delete-btn-' + data.item.id">
                                <a :disabled="!hasPermission('read_customer') ? true : false " class="action-btns1  pt-1 px-2 "
                                @click="deleteItem(data.item.id)">
                                <i class="feather feather-trash-2 text-danger"></i>
                                </a>
                            </span>
                            <b-tooltip v-if="!hasPermission('read_customer')" :target="'delete-btn-' + data.item.id" triggers="hover">
                                شما به این بخش دسترسی ندارید
                            </b-tooltip>
                        </template>
                    </b-table>
                    <Loading v-if="$root.isEmptyObject(items)" />
                    <pagination v-else-if="items.data != ''" :disabled="disabled" :limit="2" :data="items"
                        @pagination-change-page="changePage">
                    </pagination>
                    <div v-if="!items" class="alert alert-danger">
                        موردی یافت نشد
                    </div>
                </div>
            </div>
        </div>
        <CreateEditAnnouncementsModal :mode="mode" v-model="announcement" @dataSubmitted="handleDataSubmitted"/>  

        <!-- <div   
            v-for="item in items"   
            :key="item.id"   
            class="modal fade"   
            :id="'sort-stores-' + item.id"
            style="display: none;"   
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">  
                <div class="modal-content modal-content-demo">  
                    <div class="modal-header">  
                        <p class="modal-title font-weight-bold">مرتب سازی انبارهای فروشگاه حضوری گرگان</p>  
                        <button aria-label="Close" class="close" data-dismiss="modal"><span aria-hidden="true">×</span></button>  
                    </div>  
                    <div class="modal-body">  
                        <div>  
                            <h4 class="font-weight-bold mr-3">لیست تمامی انبار ها</h4>  
                            <div class="row col-12">  
                                <div   
                                v-for="store in stores"   
                                :key="store.id"  
                                class="w-30 mb-2 ml-1 py-2 text-center box-stores"   
                                :class="{ selected: isSelected(store, item.id) }"
                                @click="selectStore(store, item.id)"
                            >
                                {{ store.label }}
                            </div>   
                            </div>  
                            <div class="row col-12 d-flex justify-content-center">  
                                <div class="col-8">  
                                    <table class="table table-responsive-sm table-bordered table-hover">  
                                        <thead>  
                                            <tr>  
                                                <th>ردیف</th>  
                                                <th>شناسه انبار</th>  
                                                <th>انبار</th>  
                                            </tr>  
                                        </thead>  
                                        <tbody>  
                                            <tr v-for="(selectedStore,selectedIndex) in selectedStores[item.id] || []" :key="selectedStore.id">
                                                <td>{{ selectedIndex + 1 }}</td>  
                                                <td>{{ selectedStore.id }}</td>  
                                                <td>{{ selectedStore.label }}</td>  
                                            </tr>  
                                        </tbody>  
                                    </table>  
                                </div>  
                            </div>  
                        </div>  
                    </div>  
                    <div class="modal-footer justify-content-center">  
                        <button class="btn btn-outline-warning text-right item-right" data-dismiss="modal">بستن</button>  
                        <button class="btn btn-primary text-right item-right" @click="submitSortStores(item.id)">ذخیره مرتب سازی</button>  
                    </div>  
                </div>  
            </div>  
        </div>   -->
    </main>
</template>
<script>
import AnnouncementsLmpl from '@@/core/pages/Announcements/AnnouncementsLmpl'
export default {
    extends: AnnouncementsLmpl
}
</script>
<style scoped>
.box-stores {  
    border: 0.3px solid black;  
    border-radius: 14px;  
    cursor: pointer;  
}  
.selected {  
    background-color: aqua !important;   
}  
</style>